import {
  useSafeLayoutEffect
} from "./chunk-7RLTKGLX.mjs";

// src/portal.ts
import { createElement, useReducer, useRef } from "react";
import { createPortal } from "react-dom";
function Portal(props) {
  const { children, target } = props;
  const node = useRef(null);
  const portalNode = useRef(null);
  const [, forceUpdate] = useReducer((s) => s + 1, 0);
  useSafeLayoutEffect(() => {
    if (!node.current)
      return;
    const doc = node.current.ownerDocument;
    portalNode.current = doc.createElement("zag-portal");
    doc.body.appendChild(portalNode.current);
    forceUpdate();
    return () => {
      if (portalNode.current) {
        doc.body.removeChild(portalNode.current);
      }
    };
  }, []);
  const targetNode = target?.current ?? portalNode.current;
  if (targetNode) {
    return createPortal(children, targetNode);
  }
  return createElement("span", { ref: node });
}

export {
  Portal
};
